export default __webpack_public_path__ + "static/media/chain-13.41daf6ea.png";